import Article from "../../components/article/Article";
import { blog01, blog02, blog03, blog04, blog05 } from "./imports";

import "./blog.css";

const Blog = () => {
  return (
    <div className="gpt3__blog section__padding" id="blog">
      <div className="gpt3__blog-heading">
        <h1 className="gradient__text">
          Det händer mycket, Vi bloggar om det.
        </h1>
      </div>
      <div className="gpt3__blog-container">
        <div className="gpt3__blog-container_groupA">
          <Article
            imgUrl={blog01}
            date="mar  24, 2024"
            title="GPT-3 och Open AI är framtiden. Låt oss undersöka hur det är?"
          />
        </div>
        <div className="gpt3__blog-container_groupB">
          <Article
            imgUrl={blog02}
            date="mar  24, 2024"
            title="GPT-3 och Open AI är framtiden. Låt oss undersöka hur det är?"
          />
          <Article
            imgUrl={blog03}
            date="mar  24, 2024"
            title="GPT-3 och Open AI är framtiden. Låt oss undersöka hur det är?"
          />
          <Article
            imgUrl={blog04}
            date="mar  24, 2024"
            title="GPT-3 och Open AI är framtiden. Låt oss undersöka hur det är?"
          />
          <Article
            imgUrl={blog05}
            date="mar  24, 2024"
            title="GPT-3 och Open AI är framtiden. Låt oss undersöka hur det är?"
          />
        </div>
      </div>
    </div>
  );
};

export default Blog;
